"use client";

import type { ICmsPlatform } from "@mw/shared/payload-types";
import type { INavigationItem } from "@ui/components/navigation/types";
import { createContext } from "react";

export const MainTemplateContext = createContext<{
  platform: NonNullable<ICmsPlatform>;
  platformLink?: string;
  secondaryNav: INavigationItem[];
}>({
  platform: "default",
  secondaryNav: [],
});

export function MainTemplateContextProvider({
  children,
  platform,
  platformLink,
  secondaryNav,
}: {
  children: React.ReactNode;
  platform: NonNullable<ICmsPlatform>;
  secondaryNav: INavigationItem[];
  platformLink?: string;
}) {
  return (
    <MainTemplateContext.Provider value={{ platform, secondaryNav, platformLink }}>
      {children}
    </MainTemplateContext.Provider>
  );
}
